var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Col } from "react-bootstrap";
import styled from "styled-components";
import authentication from "@irati/auth";
import { Para } from "@irati/ui/src/Labels";
import { FormattedMessage } from "@irati/utils/lang";
import PopularRewardsQuery from "@irati/reward/apollo/query/PopularRewards";
import Search from "../Search";
import PopularReward from "./PopularReward";
var StyledDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-basis: 0;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  flex-basis: 0;\n  flex-wrap: wrap;\n"])));
var RewardSelect = /** @class */ (function (_super) {
    __extends(RewardSelect, _super);
    function RewardSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RewardSelect.prototype.render = function () {
        var onChange = this.props.onChange;
        var tenant = authentication.userTenant();
        return (React.createElement(React.Fragment, null,
            React.createElement(Search, { onChange: onChange }),
            React.createElement(Col, { xs: 12 },
                React.createElement(Para, null,
                    React.createElement(FormattedMessage, { id: "recognition.reward.picker.popularRewards", values: { tenantName: tenant.public_name } })),
                React.createElement(StyledDiv, null,
                    React.createElement(PopularRewardsQuery, null, function (_a) {
                        var popularRewards = _a.data.popularRewards;
                        return popularRewards[0].rewards.map(function (reward) { return (React.createElement(PopularReward, { key: reward.uuid, onClick: function () { return onChange(reward); }, thumbnailImage: reward.thumbnailImage })); });
                    })))));
    };
    return RewardSelect;
}(Component));
export default RewardSelect;
var templateObject_1;
